import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { Location } from '@angular/common';
import { MessageService } from '../../services/message.service';
import { ProfileService } from '../../services/profile.service';
import { UserService } from '../../services/user.service';

import { BasicError } from '../../models/error/error';
import { Thread } from '../../models/thread';
import { User } from '../../models/user';
import { Message } from '../../models/messages';
declare var $: any;

@Component({
  selector: 'app-hcp-messaging-detail',
  templateUrl: './hcp-messaging-detail.component.html',
  styleUrls: ['./hcp-messaging-detail.component.css']
})
export class HcpMessagingDetailComponent implements OnInit {
  public threadId = null;
  public thread: Thread = null;
  public messages: Array<Message> = [];
  public threadName: String = null;
  public own: User = null;
  public msg: String = null;
  public buttonClass: String = '';
  public buttonText: String = 'Senden';
  public sendingInProgress = false;
  public modalId = '#modalWindow';
  public modalTitle: String = 'Fehlender Inhalt';
  public modalText: String = 'Bitte geben Sie eine Nachricht ein um diese zu versenden';
  public scrolling = false;
  public participants = [];
  public allusers = [];
  public lastUpdateCountAllUsers = 0;
  public isEmptyUsers = false;
  public timeoutAllUsers = null;

  constructor(private route: ActivatedRoute, private location: Location,
    private messageService: MessageService, private profileService: ProfileService,
    private userService: UserService) { }

  ngOnInit() {
    this.route.paramMap.switchMap((params: ParamMap) => {
      this.threadId = params.get('id');
      this.getCurrentUser();
      return this.messageService.getThreadDetail(this.threadId)
    }).subscribe(dd => {
      if (dd instanceof BasicError) {
        console.log('Error occured while reading message');
      } else if (dd instanceof Thread) {
        this.messageService.notifyReadUpdate();
        this.thread = dd;
        // this.messages = this.thread.getMessages();
        this.messages = [];
        for (const msg of this.thread.getMessages()) {
          msg.setMessage(this.replaceForBreak(msg.getMessage()));
          this.messages.push(msg);
        }
        this.participants = this.thread.getUsers();
        this.threadName = this.thread.getSubject();
      } else {
        console.log('Could not read the thread');
      }
    });
  }

  /**
   * Getting current user
   */
  public getCurrentUser() {
    this.profileService.getMyProfile().subscribe(json => {
      if (json instanceof BasicError) {
        return;
      }

      this.own = json;
    });
  }

  /**
   * This function sends a message if the message isn't empty
   */
  public sendMessage() {
    if (this.sendingInProgress) {
      return;
    }

    this.sendingInProgress = true;

    this.buttonClass = 'sending';
    this.buttonText = 'Nachricht wird gesendet ...';

    if (this.msg === null || this.msg.length === 0) {
      this.buttonClass = '';
      this.buttonText = 'Senden';
      this.modalTitle = 'Fehlender Inhalt';
      this.modalText = 'Bitte geben Sie eine Nachricht ein um diese zu versenden';
      this.sendingInProgress = false;
      $(this.modalId).modal('show');
      return;
    }

    // Sending is in progress
    this.messageService.sendMessage(this.thread, this.msg).subscribe(json => {
      if (json instanceof BasicError) {
        console.log('Sending message failed');
        this.modalText = 'Ihre Nachricht kann zur Zeit nicht versendet werden. Bitte versuchen Sie es später erneut';
        this.modalTitle = 'Senden fehlgeschlagen';
        this.buttonReturnNormal();
        $(this.modalId).modal('show');
        this.buttonClass = 'failed';
        this.buttonText = 'Fehlgeschalgen';
        return;
      }

      // Senden war erfolgreich
      this.buttonClass = 'sended';
      this.buttonText = 'Versendet';
      this.msg = '';
      this.buttonReturnNormal();
      this.refresh();
    });
  }

  /**
   * This function returns the button to it's normal form
   */
  public buttonReturnNormal() {
    const self = this;
    setTimeout(function () {
      self.buttonClass = '';
      self.buttonText = 'Senden';
      self.sendingInProgress = false;
    }, 2000)
  }

  /**
   * Refreshing Thread
   */
  public refresh() {
    this.messageService.getThreadDetail(this.threadId).subscribe(dd => {
      if (dd instanceof BasicError) {
        console.log('Error occured while reading message');
      } else if (dd instanceof Thread) {
        this.thread = dd;
        const messages = this.thread.getMessages();

        for (const msg of messages) {
          let found = false;
          for (const m of this.messages) {
            if (m.getId() === msg.getId()) {
              found = true;
              break;
            }
          }

          if (!found) {
            msg.setMessage(this.replaceForBreak(msg.getMessage()));
            this.messages.push(msg);
          }
        }

        this.participants = this.thread.getUsers();
        this.scrolling = false;
        this.scrollBy();

      } else {
        console.log('Could not read the thread');
      }
    });
  }

  /**
   * this function replaces \n with <br>
   * @param msg message
   */
  public replaceForBreak(msg: String) {
    const re = new RegExp('\n', 'g');
    return msg.replace(re, '<br>');
  }

  /**
   * Scrolling container to deepest point
   */
  public scrollBy() {
    if (this.scrolling) {
      return;
    }

    this.scrolling = true;

    setTimeout(function () {
      document.getElementById('messages-wrapper').scrollBy(0, 100000);
    }, 200);

    setTimeout(function () {
      document.getElementById('messages-wrapper').scrollBy(0, 100000);
    }, 2000);
  }

  /**
   * User will be removed from list
   * @param user user to be removed
   */
  public removeParticipant(user: User) {
    // Removing participant from list
    const pp = [];
    for (const usr of this.participants) {
      if (usr.getID() !== user.getID()) {
        pp.push(usr);
      }
    }

    this.participants = pp;

    this.messageService.removeParticipant(this.thread, user).subscribe(json => {
      if (json instanceof BasicError) {
        console.log('Removing user failed');
        this.modalTitle = 'Teilhnehmer entfernen fehlgeschalgen';
        this.modalText = 'Der Teilnehmer konnte nicht entfernt werden. Versichern Sie' +
          'sich, dass dieser Teilnehmer nicht der Besitzer dieser Nachrichten ist';
        $(this.modalId).modal('show');
        this.participants.push(user);
      }

      // It was ok
    });
  }

  /**
   * Function to get all users
   */
  public getAllUsers() {
    if (this.allusers.length !== 0) {
      return;
    }

    $('#datatableAllUsers').dataTable().fnDestroy();
    this.lastUpdateCountAllUsers = 0;
    this.allusers = [];
    this.userService.getAllUsers().subscribe(data => {
      if (data instanceof BasicError) {
        console.log('Error occured while reading all users');
      } else if (data instanceof Array) {
        const tmp = this.allusers.concat(data);
        this.allusers = [];

        $('#datatableAllUsers').dataTable().fnDestroy();

        this.allusers = tmp;

        if (this.allusers.length !== 0) {
          this.isEmptyUsers = false;
        }
      }
    });

    if (this.allusers.length === 0) {
      this.isEmptyUsers = true;
    }
  }

  /**
   * This function updates the Rows with Userobj from all Users in the datatable
   */
  public updateRowsAllUsers() {
    if (this.lastUpdateCountAllUsers !== this.allusers.length) {
      this.lastUpdateCountAllUsers = this.allusers.length;

      if (this.timeoutAllUsers !== null) {
        clearTimeout(this.timeoutAllUsers);
      }

      this.timeoutAllUsers = setTimeout(function () {
        $('#datatableAllUsers').DataTable({
          'destroy': true,
          'pageLength': 10
        });
      }, 10);

    }
  }

  /**
   * Adding user to participants
   * @param user user to be added as participant
   */
  public addParticipant(user: User) {
    this.messageService.addParticipants(this.thread, [user]).subscribe(json => {
      if (json instanceof BasicError) {
        console.log('Could not add participant');
        this.modalTitle = 'Teilhnehmer hinzufügen fehlgeschalgen';
        this.modalText = 'Der Teilnehmer konnte nicht hinzugefügt werden. Versichern Sie' +
          'sich, dass dieser Teilnehmer existiert.';
        $(this.modalId).modal('show');
      }

      this.participants.push(user);
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/hcp-messaging-detail/hcp-messaging-detail.component.ts